export class GetPropertyError extends Error {
}
